import { render, staticRenderFns } from "./ProjectShowDatesTab.vue?vue&type=template&id=5772d39d"
import script from "./ProjectShowDatesTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowDatesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports